import { getDateString } from './helper';
import * as S from './style';

export interface TooltipFinancialProps {
  year: number;
  xAlign: 'left' | 'center' | 'right';
  $x: number;
  $y: number;
  $opacity: number;
  salesAmount?: string;
  operatingIncome?: string;
  netIncome?: string;
}

export default function TooltipFinancial({
  year,
  salesAmount,
  operatingIncome,
  netIncome,
  xAlign,
  $x,
  $y,
  $opacity,
}: TooltipFinancialProps) {
  return (
    <S.Wrapper $x={$x} $y={$y} xAlign={xAlign} $opacity={$opacity}>
      <S.Date>{year}</S.Date>
      <S.Revenue>매출액 {salesAmount}</S.Revenue>
      <S.Income>영업이익 {operatingIncome}</S.Income>
      <S.Income>당기순이익 {netIncome}</S.Income>
    </S.Wrapper>
  );
}
